/* ============================================================
   [CLAUDE] Collection filter URL-state fix | v5 2026-08-05
   Trello: https://trello.com/c/Pf925tAC (Collection Filter Issue)
   Root cause: the filter system speaks TWO url formats.
   - The AJAX filter engine writes/reads the compact format
     ?filter=stone-cut~oval-cut.emerald-cut  - this path WORKS
     end-to-end (checkboxes restored, grid re-filtered).
   - A native GET submit of the filter form (Apply button path)
     navigates to legacy params ?stone-cut=oval-cut&stone-cut=...
     which nothing parses -> page shows the unfiltered collection
     while the URL says otherwise (the oval->emerald->oval bug).
   Fix (v5): translate. When legacy filter params are present and
   no compact param, immediately location.replace() to the same
   page with the params rewritten into the compact format the
   engine understands. One extra (cached) page load, and every
   downstream step runs through the proven code path. replace()
   keeps the broken URL out of browser history.
   Loop safety: redirect only fires when |filter=| is absent, and
   the target URL always contains |filter=| -> can fire only once.
   v1-v4 lessons (kept for Ivan): checking the boxes silently is
   ignored by the engine; dispatching |change| wakes a native
   submit listener and reload-loops; the engine only applies
   filters read via applyFiltersFromUrl at its own init.
   ============================================================ */
(function () {
  'use strict';
  try {
    if (!/\/collections\//.test(window.location.pathname)) return;
    var params = new URLSearchParams(window.location.search);
    if (params.get('filter')) return; /* already compact: nothing to do */

    var reserved = /^(sort_by|filter_by_price|filter\.|page|q|preview_theme_id|utm_|_)/;
    var filterKeys = [];
    params.forEach(function (v, k) {
      if (!reserved.test(k) && v && filterKeys.indexOf(k) === -1) filterKeys.push(k);
    });
    if (!filterKeys.length) return;

    /* build compact string: key~v1.v2_key2~v3 */
    var parts = [];
    filterKeys.forEach(function (k) {
      var vals = params.getAll(k).filter(function (v) { return !!v; });
      /* dedupe */
      vals = vals.filter(function (v, i) { return vals.indexOf(v) === i; });
      if (vals.length) parts.push(k + '~' + vals.join('.'));
    });
    if (!parts.length) return;

    var next = new URLSearchParams();
    /* keep reserved params (sort, preview, etc.), drop legacy filter keys */
    params.forEach(function (v, k) {
      if (reserved.test(k) && v !== '' && !next.has(k)) next.set(k, v);
    });
    next.set('filter', parts.join('_'));

    window.location.replace(window.location.pathname + '?' + next.toString());
  } catch (e) { /* never break the page */ }
})();
